import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'tasadores',
  getAllParams: ({
    include, page, perPage, searchCode, searchName, sort, to, active, oficial,
  }) => ({
    'filter[nombre]': searchName,
    'filter[clave]': searchCode,
    'filter[activo]': active,
    'filter[oficial]': oficial,
    include,
    page,
    per_page: perPage,
    sort,
    to,
  }),
});
